import type TableView from "../../store/schema/TableView";
import clearSelection from "../../utils/clearSelection";
import { mutatorAction } from "satcheljs";

export const resetTableViewPropertiesMutator: (tableView: TableView) => void = mutatorAction("resetTableViewPropertiesMutator", function resetTableViewPropertiesMutator(tableView: TableView): void {
    tableView.isInitialLoadComplete = false;
    tableView.loadedStartIndex = 0;
    // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
    if (!tableView.rowKeys || tableView.rowKeys.length > 0) {
        tableView.rowKeys = [];
    }
    tableView.isInCheckedMode = false;
    clearSelection(tableView);
    
    // Increment the epoch to invalidate any in-flight reload responses.
    // This prevents stale reload responses from corrupting the table after a jump-to or navigation.
    tableView.tableResetEpoch = (tableView.tableResetEpoch ?? 0) + 1;
});
